import * as profileFallback from 'assets/img/UserNone.svg';
import { UserDimension } from 'modules/analytics/models/dimensions';
export class UsersControllerModel {
    constructor() {
        //Pagination
        this.itemsPerPage = 20;
        this.perPageAux = 0;
        this.users = [];
        this.profileFallback = profileFallback;
        this.userDimension = new UserDimension();
        this.canLoadMore = true;
        this.isLoading = true;
    }
}
